<template>
   <div class="hero-wrapper">
    <layouts-header />
    <index-banner />
  </div>

  <index-service></index-service>
  
  <category-four></category-four>

  <index-popular></index-popular>

  <index-cartypes></index-cartypes>

  <index-rental></index-rental>
  
  <price-four></price-four>

  <index-choose></index-choose>

  <!-- <home-faq></home-faq> -->
  <!-- <home-pricing></home-pricing> -->

  <index-blog></index-blog>

  <scroll></scroll>

  <layout-footer></layout-footer>
</template>
<style scoped>
.hero-wrapper {
  /* background: linear-gradient(to right, #0e3b2f, #2fa66b) !important; */
  background: linear-gradient(to right, #0e3b2f, #2fa66b);
  color: white;
}

</style>
